module.exports = __webpack_public_path__ + "static/media/george.a64a2485.jpeg";